import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/Base/Card";
import { cn } from "@/lib/utils";
import { Tooltip } from "@/components/Common/Tooltip";
import { Icon } from "@/components/Common/Icon";
import { IconNames } from "@/types/v2";

interface StatCardProps {
  title: string;
  subText?: string;
  moreInfoText?: string;
  value: number | string;
  loading?: boolean;
  className?: string;
}

export const StatCard = ({
  title,
  subText,
  moreInfoText,
  value,
  loading = false,
  className,
}: StatCardProps) => {
  return (
    <Card className={cn("", className)}>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
        {moreInfoText && (
          <Tooltip message={moreInfoText} asChild={false}>
            <Icon name={IconNames.info} size={14} />
          </Tooltip>
        )}
      </CardHeader>
      <CardContent>
        <div className="text-3xl font-bold">{loading ? "..." : value}</div>
        <div className="text-sm text-muted-foreground">{subText}</div>
      </CardContent>
    </Card>
  );
};
